import { Button, Input } from 'antd';
import React, { CSSProperties } from 'react';
import {
  SearchOutlined,
  CloseCircleOutlined,
  CloseCircleFilled
} from '@ant-design/icons';

import createStyles from '../utils/createStyles';
import { useState } from 'react';

export type AppSearchInputProps = {
  onSearch: () => void;
  onClear?: () => void;
  value?: React.ReactNode;
  hidden?: boolean;
  isNotEmpty?: boolean;
  disabled?: boolean;
  styleprops?: CSSProperties;
};

const AppSearchInput = React.forwardRef<typeof Input, AppSearchInputProps>(
  ({ onSearch, onClear, value, hidden, isNotEmpty, disabled, styleprops }) => {
    const [hoverIcon, setHoverIcon] = useState<boolean>(false);
    return (
      <div style={styles.container}>
        <div className="ant-input AppSearchInput" style={styles.input}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div> {value}</div>
            <div
              hidden={!isNotEmpty}
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
              }}
            >
              <span
                onMouseOver={() => {
                  setHoverIcon(true);
                }}
                onMouseOut={() => {
                  setHoverIcon(false);
                }}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center'
                }}
              >
                {!hoverIcon ? (
                  <CloseCircleOutlined
                    style={{
                      fontSize: '13px'
                    }}
                    onClick={() => onClear && onClear()}
                    className="clear-icon"
                  />
                ) : (
                  <CloseCircleFilled
                    style={{
                      color: '#00a896',
                      fontSize: '13px'
                    }}
                    onClick={() => onClear && onClear()}
                    className="clear-icon"
                  />
                )}
              </span>
            </div>
          </div>
        </div>
        <Button
          hidden={hidden}
          icon={<SearchOutlined />}
          onClick={onSearch}
          title="Search"
          disabled={disabled}
          style={styleprops ?? {}}
        />
      </div>
    );
  }
);

const styles = createStyles({
  container: {
    display: 'flex',
    alignItems: 'stretch',
    flexDirection: 'row',
    backgroundColor: '#fff',
    justifyContent: 'space-between'
  },
  input: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    marginRight: -1,
    overflow: 'hidden'
  }
});

export default AppSearchInput;
